import React, { useState, useEffect } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";

import {
  COLORS,
  emptyString,
  groupsConstants,
  inputFieldNames,
  validationConstant,
} from "../../../../views/shared-screens/constants";
import {
  Option,
  useSpinner,
  ValueContainer,
  loadingIndicator,
} from "../../../../shared";
import { groupsActions } from "../../../../views/shared-screens/redux/actions";

const { IS_VALID } = validationConstant;
const { BRAND_LOCATIONS } = inputFieldNames;

//Customer styles for react select
const styleReactSelect = (error) => {
  return {
    control: (styles) => ({
      ...styles,
      borderRadius: "6px",
      minHeight: "2.3rem",
      borderColor: error ? COLORS.SCARLET : COLORS.ASH_GREY,
      "&:hover": {
        borderColor: error ? COLORS.SCARLET : COLORS.ASH_GREY,
      },
      boxShadow: "none",
    }),
    //Changing default style of options in react select
    option: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isSelected ? "transparent" : emptyString,
      color: "black",
    }),
  };
};

const AddGroupsModal = (props) => {
  const {
    row,
    brandId,
    editMode,
    addGroup,
    brandData,
    queryString,
    allLocations,
    updateGroupDetails,
    getLocationByBrandId,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm();

  const [rowData, setRowData] = useState(row);
  const [isValid, setIsValid] = useState(true);
  const [checkedItems, setCheckedItems] = useState(
    rowData?.storesList?.length > 0
      ? rowData?.storesList.map((loc) => loc.id)
      : []
  );
  const [validate, setValidate] = useState(emptyString);
  const [selectedLocations, setSelectedLocations] = useState(
    rowData?.storesList?.length > 0 ? rowData?.storesList : []
  );

  //Handle Change function to set rowData and checkedItems
  const handleChange = (e) => {
    const { name, value } = e.target || e;
    if (name === BRAND_LOCATIONS) {
      setCheckedItems(value);
    }
    setRowData({ ...rowData, [name]: value });
  };

  //OnSubmit function to submit all the data on submission
  const onSubmit = (data) => {
    let nameLength = data.name.length;
    let nameValid = nameLength > 0 && nameLength < 200;
    let areItemsValid = checkedItems.length > 0;

    setValidate(areItemsValid ? emptyString : IS_VALID);
    setIsValid(areItemsValid);

    if (nameValid && areItemsValid) {
      let dataToSend = {
        ...data,
        brandId: brandData?.id,
        storeIds: checkedItems,
        name: rowData?.name,
      };

      if (editMode) {
        // Update group
        updateGroupDetails(
          { ...dataToSend, id: rowData.id },
          brandId,
          queryString
        );
      } else {
        // Adding group
        addGroup(dataToSend);
      }

      resetState();
      props.onClose();
    }
  };

  //Function to reset states
  const resetState = () => {
    reset();
    setRowData({});
    setCheckedItems([]);
    setIsValid(true);
    setValidate(emptyString);
    setSelectedLocations([]);
  };

  // Show loading while a request is running.
  const spinner = useSpinner();

  // Validation on checked items
  useEffect(() => {
    if (!isValid) {
      if (checkedItems.length !== 0) {
        setValidate(emptyString);
      } else {
        setValidate(IS_VALID);
      }
    }
    // eslint-disable-next-line
  }, [checkedItems]);

  useEffect(() => {
    if (brandId) getLocationByBrandId(brandId);
    // eslint-disable-next-line
  }, []);

  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      animation={props.animate}
      size={props.ModalSize}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {!editMode ? props.AddFranchiseText : props.UpdateFranchiseText}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="name" className="mt-2 col-sm-3 fw-bold">
                  Brand Name:
                </label>
                <span className="col-sm-3">{brandData?.name}</span>
              </div>
              <div className="form-group mb-3 fw-bold">
                <label className="mb-1" htmlFor="name">
                  Group Name:
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : emptyString
                    }`}
                  name="name"
                  value={rowData?.name}
                  placeholder="Enter name"
                  {...register("name", {
                    required: true,
                    maxLength: "200",
                    minLength: "1",
                    onChange: (e) => handleChange(e),
                  })}
                />
              </div>
              <div className="form-group mb-3 ">
                <h6 className="fw-bold" htmlFor="brandLocationId">
                  Stores:
                </h6>
                <Controller
                  name="Locations"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={selectedLocations}
                      closeMenuOnSelect={false}
                      options={
                        rowData?.storesList
                          ? [...rowData.storesList, ...allLocations]
                          : allLocations
                      }
                      components={{
                        Option,
                        ValueContainer: ValueContainer,
                        IndicatorSeparator: () => null,
                        LoadingIndicator: loadingIndicator,
                      }}
                      isMulti
                      hideSelectedOptions={false}
                      maxMenuHeight={200}
                      getOptionValue={(option) => option.id}
                      getOptionLabel={(option) => option.name}
                      onChange={(e) => {
                        let obj = {
                          name: BRAND_LOCATIONS,
                          value: e.map((loc) => loc.id),
                          checked: true,
                        };
                        handleChange(obj);
                        setSelectedLocations(e);
                      }}
                      placeholder="Select Stores"
                      isSearchable={true}
                      styles={styleReactSelect(validate)}
                      className="w-100 font-14-px text-secondary"
                      id="locations"
                      isDisabled={spinner(groupsConstants.GROUPS_DATA)}
                      isLoading={spinner(groupsConstants.GROUPS_DATA)}
                    />
                  )}
                  rules={{
                    required: validate,
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant={props.SubmitButtonVariant}
            className={props.SubmitButtonClasses}
            style={props.SubmitButtonStyle}
            type="submit"
          >
            {!editMode ? props.SubmitButtonText : props.UpdateButtonText}
          </Button>
          <Button
            variant={props.CancelButtonVariant}
            className={props.CancelButtonClasses}
            style={props.CancelButtonStyle}
            onClick={props.onClose}
          >
            {props.CancelButtonText}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  brandData: state.storesReducer.store,
  allLocations: state.groupsReducer.allLocations,
});

const mapDispatchToProps = (dispatch) => ({
  addGroup: (body) => dispatch(groupsActions.addGroup(body)),
  updateGroupDetails: (body, brandId, queryString) =>
    dispatch(groupsActions.updateGroupDetails(body, brandId, queryString)),
  getLocationByBrandId: (brandId) =>
    dispatch(groupsActions.getLocationByBrandId(brandId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddGroupsModal);
